import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { formatDateG, formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import "./Admin.css";
import "../admin.css";

const AdminMailConfirm = ({his, members, fields, isLoading, handleMailSubmit, backFromMail, mailTos})  => {
  const backFromMail0 = (e) => {
    console.log('aaa');
  }
  const getName = (i) => {
      console.log('getName...');
      console.log(i);
      console.log(his.dests[i].familyName);
      console.log(his.dests[i].givenName);
      return fields ? (members[i].familyName + ' ' + members[i].givenName) : (his.dests[i].familyName + ' ' + his.dests[i].givenName);
  }
  const getFormatDate = (t) => {
    const d = new Date(t);
    return formatDateG(d, 'yyyy/MM/dd HH:mm');
  };
  return (

        <section id="contents">
          <h2>メール送信 内容確認</h2>
          <div id="create_mail">
            <h3>配信メール内容</h3>
            <Table className="listtbl">
              <tbody>
                <tr>
                  <th>タイトル</th>
                  <td>{fields ? fields.subject : his.subject }&nbsp;</td>
                </tr>
                <tr>
                  <th>本文</th>
          <td>{ fields ? fields.mailBody.split('\n').map((s) =>  ( <p className="newLine">{s}</p> )) : his.mailBody.split('\n').map((s) =>  ( <p className="newLine">{s}</p> )) }&nbsp;</td>
                </tr>
              </tbody>
            </Table>
          <div id="send_list">
            <h3>配信先一覧</h3>
            <Table className="listtbl">
              <caption>1 ページ目</caption>
              <tbody>
                <tr>
                  <th>応募者</th>
                  <th>応募者（かな）</th>
                  <th>email</th>
                  <th>受付日</th>
                  <th>更新日</th>
                </tr>
              { mailTos.map((i) => (
                <tr>
                  <td>{members[i].familyName} {members[i].givenName}</td>
                  <td>{members[i].familyNameKana} {members[i].givenNameKana}</td>
                  <td>{members[i].affiliationEmail }</td>
                  <td>{members[i].admissionDate}</td>
                  <td>{getFormatDate(members[i].updatedAt)}</td>
                </tr>
              ))}
              </tbody>
            </Table>
          </div>
          <div className="opBtns">
          <Button id="backToInput" active size="lg" active onClick={ backFromMail } >
          戻る
           </Button>
          { fields ? (
          <LoaderButton
            block
            size="lg"
            type="button"
            variant="success"
            isLoading={isLoading}
            id="mailSubmit"
            onClick={handleMailSubmit}
          >
            送信
              </LoaderButton> ) : <></> }
        </div>
          </div>
      </section>
  );
}

export default AdminMailConfirm;
